// TODO: delete this file together with the funding_overview_in_bootstrap_5 once we keep new version
import 'jquery';
import { listenToAnchorClicks } from '../../src/funding_overview/funding_overview';
import '../../src/funding_overview/funding_overview.scss';

listenToAnchorClicks();
